import { RootState } from 'store/store';
import { CurrentProgram, User } from './AuthTypes';

export const getAccessToken = (s: RootState): string | null => s.auth.accessToken;
export const getTokenType = (s: RootState): string | null => s.auth.tokenType;

export const getUserInfo = (s: RootState): User | null => s.impersonation.user || s.auth.user;
export const getIsLoggedIn = (s: RootState): boolean =>
  Boolean(s.impersonation.accessToken || s.auth.isLoggedIn);
/** A support session may inspect user data, but must never mutate it. */
export const getIsImpersonating = (s: RootState): boolean => Boolean(s.impersonation.accessToken);
export const getAuthError = (s: RootState): string | null => s.auth.error;
export const getAuthLoading = (s: RootState): boolean => s.auth.loading;
export const getAuthInitialized = (state: RootState): boolean =>
  Boolean(state.impersonation.accessToken || state.auth.initialized);
export const getEmailVerified = (s: RootState): boolean => Boolean(getUserInfo(s)?.email_verified);

export const getInstanceId = (s: RootState): number | null => getUserInfo(s)?.instance_id ?? null;
/* проходил ли пользователь тест */
export const getHasPassedTest = (s: RootState): boolean => !!getUserInfo(s)?.is_actual;

/* Есть ли результаты витаминов */
export const getVitaminsPassed = (s: RootState): boolean => {
  const items = getUserInfo(s)?.last_order?.items ?? [];
  return items.some(
    (item: any) =>
      item.type === 'vitamins' && (item.status === 'RESULTED' || item.status === 'EXPIRED'),
  );
};

export const getVitaminsResulted = (s: RootState): boolean => {
  const items = (getUserInfo(s)?.last_order?.items as { type: string; status: string }[]) ?? [];
  return items.some(item => item.type === 'vitamins' && item.status === 'RESULTED');
};

export const getLastSurveyDate = (s: RootState): string | null =>
  getUserInfo(s)?.last_survey_completed_at ?? null;

export const getCurrentProgram = (s: RootState): CurrentProgram | null =>
  getUserInfo(s)?.current_program ?? null;

export const getNeedSurveyNotification = (s: RootState): boolean =>
  Boolean(getUserInfo(s)?.current_program?.need_survey_notification);

export const getHasActiveProgram = (s: RootState): boolean => {
  const cp = getUserInfo(s)?.current_program;
  if (!cp?.start_date || !cp?.end_date) return false;
  const today = new Date().toISOString().slice(0, 10); // YYYY-MM-DD
  return cp.start_date <= today && today <= cp.end_date;
};
